import React from 'react';
import { Paper, Grid, InputLabel, Typography, Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  progress: {
    color: theme.palette.background.paper
  },
  label: {
    fontSize: '12px'
  },
  field: {
    fontSize: '14px'
  }
}));

const providerColumns = [
  {
    title: 'Company Name',
    field: 'companyName',
    type: 'string'
  },
  {
    title: 'Primary Email',
    field: 'primaryEmail',
    type: 'string'
  }
];

interface ProviderHeaderProps {
  data: participant;
}
type participant = {
  [key: string]: any;
};

const ProviderHeader = (props: ProviderHeaderProps) => {
  const classes = useStyles();

  let { data } = props;

  return (
    <Paper variant="outlined">
      <Box p={2}>
        <Grid container spacing={2}>
          {Object.keys(data).length !== 0 &&
            providerColumns.map(({ title, field, type }) => (
              <Grid key={title} item sm={3}>
                <InputLabel className={classes.label}>{title}</InputLabel>
                <Typography className={classes.field}>{data?.[field]}</Typography>
              </Grid>
            ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default ProviderHeader;
